import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { SnackbarKey } from 'notistack';

import { INotification, INotificationsState, IToast } from './slice.interface';

const initialState: INotificationsState = {
  list: [],
};

export const notificationsSlice = createSlice({
  name: 'notifications',
  initialState,
  reducers: {
    enqueueSnackbar: (state, action: PayloadAction<INotification>) => {
      const key = action.payload.options && action.payload.options.key;

      state.list = [...state.list, { key, ...action.payload }];
    },
    removeSnackbar: (state, action: PayloadAction<SnackbarKey>) => {
      state.list = state.list.filter((notification: IToast) => notification.key !== action.payload);
    },
  },
});

export const { enqueueSnackbar, removeSnackbar } = notificationsSlice.actions;

export default notificationsSlice.reducer;
